import { useGetServerInfoQuery } from '@/features/api/endpoints/directusEndpoints';

const url = import.meta.env.VITE_DIRECTUS_URL;

export const useGetDirectusProjectLogo = () => {
  const { data } = useGetServerInfoQuery();

  if (data?.project_logo) {
    return `${url}/assets/${data.project_logo}`;
  }
  return null;
};
